"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_converged__proposition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "converged-proposition-mid"), /*#__PURE__*/React.createElement("g", {
    id: "a6b45ac9-045b-450f-bd97-91094858b76a",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4daf5455-0106-40e4-a530-5670fe8e2971",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "9baa6003-ca98-4210-8191-faabd52447be",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("line", {
    id: "f4a02ad8-5d52-48a4-a38e-33d9af779c3f",
    "data-name": "<Pfad>",
    x1: 81.07,
    y1: 150,
    x2: 122,
    y2: 150,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("line", {
    id: "dd7985d2-cf81-4e35-8e69-3b28b389e119",
    "data-name": "<Pfad>",
    x1: 67.35,
    y1: 134,
    x2: 138,
    y2: 134,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "2d8df307-61ba-4604-ad6e-3f4d9dac01ac",
    "data-name": "<Pfad>",
    d: "M166,86V56a14,14,0,0,0-14-14H40A14,14,0,0,0,26,56V79.08",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 150,
    x2: 96,
    y2: 134,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 146,
    x2: 166,
    y2: 146,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 86,
    width: 44,
    height: 72,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "179fe8bb-97f0-4811-900a-077e7799b4d4",
    "data-name": "<Pfad>",
    d: "M105.5,101.88a13.47,13.47,0,0,0-19,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "8b648d82-bc3f-4942-b00d-30d7d6e75a3c",
    "data-name": "<Pfad>",
    d: "M115,89.93l0,0h0a26.94,26.94,0,0,0-38.07,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "928f1f41-0d28-4124-a134-8b2b01e80e66",
    "data-name": "<Pfad>",
    d: "M124.53,77.89a40.41,40.41,0,0,0-57.06-.05",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "4b2a4a11-d426-4683-89de-cbbe55b1197a",
    "data-name": "<Pfad>",
    d: "M54.84,136.67,62,133c1.83-.57,3.6-.49,4.54.31,1.42,1.21,13.23,12.1,14.22,13.06s1.13,3.23-.81,5.1S68.5,161.61,65.5,161s-15.51-3-35-30S12.93,91.91,13.37,89,24.68,79.61,27.16,78.5s4.64-.17,5.23,1c.67,1.35,7.12,15.74,7.82,17.38.48,1.12-.07,2.77-1.25,4.23s-6,7-6,7,1.81,4.7,9,14.65C45.41,127.63,54.84,136.67,54.84,136.67Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

var _default = ic_converged__proposition;
exports.default = _default;